import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { plotBackground } from "../../../config/colors";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import LoadingChart from "../../Home/components/loadingChart";
import "../Tostador.css";

export default function PerfilTermocuplaSuperiores() {
  const [termocupla244, setTermocupla244] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [termocupla241, setTermocupla241] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [termocupla242, setTermocupla242] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [termocupla243, setTermocupla243] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });
  const [isLoading, setIsLoading] = useState(true);

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 4,
    secuencia: 13,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      setIsLoading(true);
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateTermocupla244(data);
      populateTermocupla241(data);
      populateTermocupla242(data);
      populateTermocupla243(data);

      //#endregion
      setTimeout(() => {
        fetchData();
      }, 300000);
      setIsLoading(false);
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTermocupla244(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estadoTermo244 = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 244"
    );
    // Filter: Estado Termocupla 244
    const estadoTermocupula244 = data.filter(
      (element) => element.Detalle === "Estado Termocupla 244"
    );

    estadoTermo244.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    estadoTermocupula244.forEach((element) => {
      arrEstado.push(element.Valor);
    });
    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });
    setTermocupla244({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }

  function populateTermocupla241(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estadoTermo244 = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 241"
    );
    // Filter: Estado Termocupla 244
    const estadoTermocupula244 = data.filter(
      (element) => element.Detalle === "Estado Termocupla 241"
    );

    estadoTermo244.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    estadoTermocupula244.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setTermocupla241({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }

  function populateTermocupla242(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estadoTermo244 = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 242"
    );
    // Filter: Estado Termocupla 244
    const estadoTermocupula244 = data.filter(
      (element) => element.Detalle === "Estado Termocupla 242"
    );

    estadoTermo244.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    estadoTermocupula244.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setTermocupla242({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }

  function populateTermocupla243(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrEstado = [];
    // Filter: Temperatura Termocupla 244
    const estadoTermo244 = data.filter(
      (element) => element.Detalle === "Temperatura Termocupla 243"
    );
    // Filter: Estado Termocupla 244
    const estadoTermocupula244 = data.filter(
      (element) => element.Detalle === "Estado Termocupla 243"
    );

    estadoTermo244.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    estadoTermocupula244.forEach((element) => {
      arrEstado.push(element.Valor);
    });

    setTermocupla243({
      fecha: arrFechas,
      value: arrValues,
      estado: arrEstado,
    });
  }
  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart
              plotBackgroundColor={plotBackground}
              title={"Perfil Termocuplas Superiores"}
              subtitle={"Periodo " + date.start + " - " + date.end}
            >
              {/** -------------------------------- Termocupla 241 --------------------------------------- */}
              <Chart.Line
                name="Temperatura 241"
                data={termocupla241.value}
                color="blue"
                yAxis={0}
                min={600}
                max={800}
              />

              {/** -------------------------------- Termocupla 242 --------------------------------------- */}
              <Chart.Line
                name="Temperatura 242"
                data={termocupla242.value}
                color="yellow"
                yAxis={0}
                min={600}
                max={800}
              />

              {/** -------------------------------- Termocupla 243 --------------------------------------- */}
              <Chart.Line
                name="Temperatura 243"
                data={termocupla243.value}
                color="green"
                yAxis={0}
                min={600}
                max={800}
              />

              {/** -------------------------------- Termocupla 244 --------------------------------------- */}
              <Chart.Line
                name="Temperatura 244"
                data={termocupla244.value}
                color="red"
                yAxis={0}
                min={600}
                max={800}
              />

              {/** -------------------------------- FECHAS --------------------------------------- */}
              <Chart.XAxis categories={termocupla244.fecha} />

              <Chart.YAxis
                labelSuffix=" °C"
                title="temperatura, °C"
                lineWidth={2}
                lineColor="white"
              />
              <Chart.YAxis opposite={true} lineWidth={2} lineColor="white" />

              <Chart.Tooltip valueSuffix=" °C" />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
